/* eslint-disable */
export default {
  to: 'À :',
  enterNameOrPhoneNumber: 'Entrer le numéro',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"enterNameOrPhoneNumber"@#@ @source: @#@"Enter Number"@#@
